import { faRankingStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Modal from "../../modal/modal";
import CalculateRevenue from "../../modal/pipline-modal/CalcularteRevenue";

interface PipelineData {
  pipeline_id : number;
  cdd_name: string;
  client_id : number;
  role : string;
  revenue: string;
  processed_date: string; 
  status: number;
  notes: string;
  projected_start_date: string; 
  client_name: string;
  career_level: string;
  cdd_num: string;
  add_candidates_or_switch_roles: string;
  last_update : string;
}

interface btnProps {
    pipeline : PipelineData[];
}

const CalculateRevenueBtn : React.FC<btnProps> = ({ pipeline }) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);

    function createModalContent(content : React.JSX.Element){
        setModalChildren(content);
        setShowModal(true);
    }

    return (
        <div>
            <button type="button" onClick={()=>createModalContent(<CalculateRevenue pipeline={pipeline} />)} className="uppercase text-md bg-gray-50 px-2 py-1 shadow hover:bg-gray-200">
                <FontAwesomeIcon icon={faRankingStar} className="text-gray-700" /> &nbsp;
                View Revenue
            </button>
            {showModal && (
                <Modal onClose={()=>{setShowModal(false)}}> 
                    {modalChildren}
                </Modal>
            )}
        </div>
    );
}

export default CalculateRevenueBtn;